/**
 * Where an offer is in its life.
 *
 * WHY THIS IS NOT THE SAME AS "IS IT ON"
 * --------------------------------------
 * An offer can be switched on and still not be doing anything: it starts next
 * Friday, it ended last month, or the hundred vouchers have all been used. A
 * list that shows only on-or-off makes somebody open each one to find out why
 * a code is being refused at the till.
 *
 * The order of the checks matters. A stopped offer is stopped whatever its
 * dates say, and an offer that has not started yet has not been used up even
 * if its counter says otherwise — so the answer is the first thing that is
 * true reading downwards, which matches how a person would explain it.
 */
import { today } from '@foodrun/shared';

export function statusOf(offer, day = today()) {
  if (!offer.is_active) return { label: 'Stopped', tone: 'text-ink-3' };
  if (offer.start_date > day) return { label: `From ${offer.start_date}`, tone: 'text-ink-2' };
  if (offer.end_date && offer.end_date < day) return { label: 'Ended', tone: 'text-ink-3' };

  if (
    offer.max_uses !== null &&
    offer.max_uses !== undefined &&
    offer.used_count >= offer.max_uses
  ) {
    return { label: 'Used up', tone: 'text-warn' };
  }

  return { label: 'Running', tone: 'text-brand-400' };
}
